
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.609 9.1a8.5 8.5 0 01-8.5 8.5 8.5 8.5 0 01-8.5-8.5c0-4.693 3.806-8.5 8.5-8.5s8.5 3.807 8.5 8.5zm-8.5 1.713a1.577 1.577 0 100 3.154 1.577 1.577 0 000-3.154zM7.612 5.146l.254 4.662a.411.411 0 00.41.388h1.665c.218 0 .399-.17.41-.388l.255-4.662a.411.411 0 00-.411-.433H8.023a.411.411 0 00-.411.433z","fill":"#282E3E"}})])
          )
        }
      }
    